
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as linksoXgjgWI0umSy8OOpfQgiSluEYRDCXDycPyzVmtgMbywMeta } from "/opt/buildhome/repo/pages/links.vue?macro=true";
import { default as pausedsyQK2H82o6L_45W03mBCd9yuTc_45uQtxdWP0JfD7Ndk1BgMeta } from "/opt/buildhome/repo/pages/paused.vue?macro=true";
import { default as index_45oldgFJJbg265pHuZuI_45piesULI8HCkW2gZknt6yLT1stA8Meta } from "/opt/buildhome/repo/pages/index-old.vue?macro=true";
import { default as thank_45youMf0D2DMfVQowzLPcdgRvJnp5tPsBBhMYHuLtpS_IJrwMeta } from "/opt/buildhome/repo/pages/thank-you.vue?macro=true";
import { default as loginwro5JqY_h5KW7eQAaFtLac9N8BWQRX9jADT3dnAvGxgMeta } from "/opt/buildhome/repo/pages/auth/login.vue?macro=true";
import { default as magic4KHZnuClAmnOJnpC01lpbcjLL2y3tGw7JVspTUAY0LUMeta } from "/opt/buildhome/repo/pages/auth/magic.vue?macro=true";
import { default as cafeteriasa24vZD4Iqy5AWoTKCMqZHyTTV_NHA7H5h7yJ3lROSxMMeta } from "/opt/buildhome/repo/pages/cafeterias.vue?macro=true";
import { default as contact_45usL5sA0Zp5dgV4Bd8KjQI9Pm2HbGOBREFE542cDiDC_P8Meta } from "/opt/buildhome/repo/pages/contact-us.vue?macro=true";
import { default as heladeriasm9UFBKKI2SzmGVH1Zam_45r5yhVwFU0YPf_K_453Ji9H7r4Meta } from "/opt/buildhome/repo/pages/heladerias.vue?macro=true";
import { default as acceptQMziQc88ykVgPf7xRYijtBm9MBpi3jdgUQGQqbNycjMMeta } from "/opt/buildhome/repo/pages/auth/accept.vue?macro=true";
import { default as logoutgU_G4QHH66XaZEr3gUo0k9EyXTJMADGobsXma60gyPwMeta } from "/opt/buildhome/repo/pages/auth/logout.vue?macro=true";
import { default as unauthorizedT6bVzQtrm0wq5Ee_45kre8DjucvPItFNERR8dRfIs9lZAMeta } from "/opt/buildhome/repo/pages/unauthorized.vue?macro=true";
import { default as addGUc158IxqdJOzgeYV92voxgodN4om3eWLFXaHaYONnwMeta } from "/opt/buildhome/repo/pages/app/combos/add.vue?macro=true";
import { default as test_45renderershz0dAOn9bpoL72LJ4qQuD4hgAQiaCMzSvzrHF7_45xBn8Meta } from "/opt/buildhome/repo/pages/test-renderers.vue?macro=true";
import { default as indexBW6CbCcVwx1gWzJxQ8wQSENQN8FIJiqOWP1ocVRKAn8Meta } from "/opt/buildhome/repo/pages/app/cache/index.vue?macro=true";
import { default as indexe8KllPMvIq_45SV1VRqFMYTYn3604DPSl_yu7VNg00j8wMeta } from "/opt/buildhome/repo/pages/app/users/index.vue?macro=true";
import { default as indexShzoG6MxpypNRrYY1wQoENwGVj2y0WkJ0jtn1HYPazgMeta } from "/opt/buildhome/repo/pages/store/pos/index.vue?macro=true";
import { default as _91shiftId_93VjbLHoiVSfQM58YvF8nB5nCfdtc7KsBDITjSpdDHjFMMeta } from "/opt/buildhome/repo/pages/store/pos/shift/[shiftId].vue?macro=true";
import { default as shift1bdjLmSaJYmHpFHgufOC4ggSYZaWE3e_ipbVtc4hb7oMeta } from "/opt/buildhome/repo/pages/store/pos/shift.vue?macro=true";
import { default as auditTtuCPwIR53xmPUjhjyKG_45VWJJ5QYAo4WFT4GiahNk3IMeta } from "/opt/buildhome/repo/pages/app/checks/audit.vue?macro=true";
import { default as indexc15Hj1RNSyVH5Sqg4LuHK8QKyCkac6A_21vihS70bloMeta } from "/opt/buildhome/repo/pages/app/checks/index.vue?macro=true";
import { default as indexXE0IWh3d9H4rgeSliI638Jg_45thoELGUCMV4udG9Yg6EMeta } from "/opt/buildhome/repo/pages/app/combos/index.vue?macro=true";
import { default as auditkCzaRtr9pV69STqKoKb6YtSK7zP51k3NU_45_45IxNbeOqcMeta } from "/opt/buildhome/repo/pages/app/orders/audit.vue?macro=true";
import { default as indexfsJcZBO8KinUMNXFsa_sOy7U5UkX6O16qs1PwV6G_45d0Meta } from "/opt/buildhome/repo/pages/app/orders/index.vue?macro=true";
import { default as productsPn4A3_4526TlQFhEKRRIY9QCjE748GYjUp_450mTXsWje2kMeta } from "/opt/buildhome/repo/pages/app/poc/products.vue?macro=true";
import { default as addMw3owUdOyB0ov8VgWNF5H4h6JPRjQYRUqUrWLhqJLXAMeta } from "/opt/buildhome/repo/pages/app/products/add.vue?macro=true";
import { default as indexQdiYHXy94eff7zVdeCF6kY43SRGGR2KBmmXbLG1B8acMeta } from "/opt/buildhome/repo/pages/app/shifts/index.vue?macro=true";
import { default as index9BfHbU80pTr1tod_45E848_C0c48lr_Rpigs5afLlqyEQMeta } from "/opt/buildhome/repo/pages/app/tables/index.vue?macro=true";
import { default as no_45businessia2H5DM43n925qQLcQqGoBFFsx3VLOR8oQ1QvjGCnvsMeta } from "/opt/buildhome/repo/pages/auth/no-business.vue?macro=true";
import { default as combosG7oG_45vECdHGtDRiaE66KFjfNub5mHKxTVqywJC2xO3cMeta } from "/opt/buildhome/repo/pages/store/pos/combos.vue?macro=true";
import { default as addjuZ_45iJmNH9bc_45O7eGRClaJY6qYsLPA7ymVzSEAZxvd4Meta } from "/opt/buildhome/repo/pages/app/customers/add.vue?macro=true";
import { default as _91uuid_93YD48OVIoyd1wOIF6wOtLXO0VaHls_wkrH4FLEnuNuv4Meta } from "/opt/buildhome/repo/pages/app/orders/[uuid].vue?macro=true";
import { default as listsHkKtvszNv4zRjg5I1TfLD_45J9waYbcVkTy9ZkRArj_MMeta } from "/opt/buildhome/repo/pages/app/products/list.vue?macro=true";
import { default as indexolvE5_45NVAUYBB6YmiBl_BBTVLDSSzsED5OKpbZ0nx7IMeta } from "/opt/buildhome/repo/pages/app/recipes/index.vue?macro=true";
import { default as indexHHMgcZIu3Nt31I5LCLVnat1EDqFg9bJ0rUpsKDV3W74Meta } from "/opt/buildhome/repo/pages/app/reports/index.vue?macro=true";
import { default as indexSKYEo0e_45YqMDkaqT7YI5Pf_HsYAqDuRFDcb_wN5Smu4Meta } from "/opt/buildhome/repo/pages/app/servers/index.vue?macro=true";
import { default as set_45passwordGKvjchYmnuxPfkEeCkxZmf_45262I4RqbTTzl5trDzzDgMeta } from "/opt/buildhome/repo/pages/auth/set-password.vue?macro=true";
import { default as index9e3rgNKpikcF9bhBs681GWqNjZ1XJzmgiSAGLeoZ5MwMeta } from "/opt/buildhome/repo/pages/super-admin/index.vue?macro=true";
import { default as indexMbptbF10kzZFETjDbqqvyT76vW_pKA3CapCR3O9mwdEMeta } from "/opt/buildhome/repo/pages/app/business/index.vue?macro=true";
import { default as indexh8dhAqplKt80eWTZIOX5jeZmD9UJI6QBapzJMOjRJVAMeta } from "/opt/buildhome/repo/pages/app/expenses/index.vue?macro=true";
import { default as indexqw3meEakqKPOx_bcFwNa66yoAe9kO6zxrDh2TSqS2PoMeta } from "/opt/buildhome/repo/pages/app/products/index.vue?macro=true";
import { default as confirm_45emailaQ0xIiLuhyYLg9oTmJL9Cy4lsSkvruqwkoOnvW7kn50Meta } from "/opt/buildhome/repo/pages/auth/confirm-email.vue?macro=true";
import { default as createZbOMBl5Pslf9cj0gH0B6PiaYL2wHPZO2FyiocsVcrYYMeta } from "/opt/buildhome/repo/pages/app/business/create.vue?macro=true";
import { default as indexpKz3rwmjFSo8ve_l9ppabEyxpzyv9vA2ACnE2ZQT2fYMeta } from "/opt/buildhome/repo/pages/app/customers/index.vue?macro=true";
import { default as indexOANRVXZmdIAE28NckOF_b6l3GMrhf3YM4rALvgDpp1oMeta } from "/opt/buildhome/repo/pages/app/discounts/index.vue?macro=true";
import { default as indexJQ210kovHWmSgT2nIo5KUZTCFR32by8hgdUktRT8K4MMeta } from "/opt/buildhome/repo/pages/app/financial/index.vue?macro=true";
import { default as indexMrO1p01kuYTK3JtzAQYbqpJ7kzSUrHgbM7FEPbxk_45vkMeta } from "/opt/buildhome/repo/pages/app/modifiers/index.vue?macro=true";
import { default as importOMMkcwdVtK5_w9IWZw9wVA3SmsQ2C1grPkW_FEvF690Meta } from "/opt/buildhome/repo/pages/app/products/import.vue?macro=true";
import { default as reset_45passwordVxuQyUMBySjF4TTBevFLXice7Yi56zw2bZYHEWNi0ewMeta } from "/opt/buildhome/repo/pages/auth/reset-password.vue?macro=true";
import { default as testd_PgHfO70uDMb7vPCxLck49Ub8xfZSJkbsPA2vjXxcMMeta } from "/opt/buildhome/repo/pages/public/[buuid]/test.vue?macro=true";
import { default as inventorypKF8ZjbTvjiDzm39ogLM0aIq1sx6YoJKy1_45j0F64IgsMeta } from "/opt/buildhome/repo/pages/store/pos/inventory.vue?macro=true";
import { default as indexH8Kc4CWtTg_nrsenK4gnl7DLwRFVFJ_tSAhAn_45a55e4Meta } from "/opt/buildhome/repo/pages/store/pos/kds/index.vue?macro=true";
import { default as indexjeSnNEYYAcz_45BImCGanjyWmO7mmTejcMW5a_h7H899gMeta } from "/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/index.vue?macro=true";
import { default as email_45testwih0Sx_eGmIKD2Hu3bAa5xdAVXSxnzto3y41V3lNZpEMeta } from "/opt/buildhome/repo/pages/app/admin/email-test.vue?macro=true";
import { default as index3hMtL7kpiEKtsKSXdhFsypTof4Ms_9nWLXrj4RsYwbMMeta } from "/opt/buildhome/repo/pages/app/categories/index.vue?macro=true";
import { default as _91shiftId_9394imajGxe0ogKrb1XiMNEH6T_DM_1B5hNGRYuuxMEP8Meta } from "/opt/buildhome/repo/pages/app/shifts/[shiftId].vue?macro=true";
import { default as forgot_45passwordioOe1ufgzy0WtUzM0b2zzf2yOkTqOjLSGnCYiaXaYXIMeta } from "/opt/buildhome/repo/pages/auth/forgot-password.vue?macro=true";
import { default as select_45businessoRlt_45Bwp5L5RPhDAA8LVVqL7peOF1zKj_450LB9oVHzMEMeta } from "/opt/buildhome/repo/pages/auth/select-business.vue?macro=true";
import { default as switch_45businessfcHniMNRWU7EQQ1eWpNErTHAE5Ic5kWsATwNUuaQ_j4Meta } from "/opt/buildhome/repo/pages/auth/switch-business.vue?macro=true";
import { default as clearu7ATq7ph7x1XWmHHZaVdbt4evW_452IXTLKjZslMvTXJ8Meta } from "/opt/buildhome/repo/pages/public/[buuid]/clear.vue?macro=true";
import { default as indexyjKrT_Gz4WtkCONq9hH4UmFTUKGB2dqZGFcJ8n1OWzQMeta } from "/opt/buildhome/repo/pages/public/[buuid]/index.vue?macro=true";
import { default as loginEnSIS3ooY1q5RGolUfqvBIbLXn5tQOhz8_45i8GmPA2xgMeta } from "/opt/buildhome/repo/pages/public/[buuid]/login.vue?macro=true";
import { default as indexfuE8bwNB8TXg0rY1jD_45KY0XQeDNtaZRO87aT2ZsCJQ8Meta } from "/opt/buildhome/repo/pages/store/products/index.vue?macro=true";
import { default as indexzSFF5WzeJF68_45Ou9fzU_kiuBJGxRLBB2V8xeRzfcf98Meta } from "/opt/buildhome/repo/pages/app/ingredients/index.vue?macro=true";
import { default as indexOnB2KbcUqUff2IGeqUEHwVHUwTW55ovE2zRe4cKrJrkMeta } from "/opt/buildhome/repo/pages/app/stock-items/index.vue?macro=true";
import { default as pos_45configMQd3L2vx3fV5AJx9TByYkeHMr3BKvhMflTrGXPTk3mMMeta } from "/opt/buildhome/repo/pages/app/system/pos-config.vue?macro=true";
import { default as indexJfDTaqhp263L95QGRw9_aWYOmmKPDSenbu0qecjK4lIMeta } from "/opt/buildhome/repo/pages/app/testing/jwt/index.vue?macro=true";
import { default as combosxkGf7ST_45auhsy83Vv9fHw9wj0MTE4L0YdcN_45OVTdx2UMeta } from "/opt/buildhome/repo/pages/public/[buuid]/combos.vue?macro=true";
import { default as reviewkrx7LUDdpkCvkzv7T2cYKjY277olavp0aZlBdZjF_k0Meta } from "/opt/buildhome/repo/pages/public/[buuid]/review.vue?macro=true";
import { default as verifyoG_45QNuXOk0jnopwCoHMkxHzgK7P0z4RfVsBPo_m5kUcMeta } from "/opt/buildhome/repo/pages/public/[buuid]/verify.vue?macro=true";
import { default as gridCKZlWYdKk764dtyY7vbNNlQ0GfIx0NnV0IJlpq4BTysMeta } from "/opt/buildhome/repo/pages/store/pos/orders/grid.vue?macro=true";
import { default as add8hR6kXFOlH5fVTbkYCqf1t0L1SzY3PMkVbnNtWMfXzkMeta } from "/opt/buildhome/repo/pages/super-admin/users/add.vue?macro=true";
import { default as indexB0nunpozYW_45Scs7gF6Vb5JUmAHaCq6hQGATwndWExIoMeta } from "/opt/buildhome/repo/pages/app/dining-areas/index.vue?macro=true";
import { default as indexYeq_45ZeCKdGYG7PIJpZcQaTFcbyMCb3U5o_QUkEQDJVcMeta } from "/opt/buildhome/repo/pages/app/kds-stations/index.vue?macro=true";
import { default as paymente_45tBk4_45MDo6eqewErENnAuhcDehCycWDwSsW_45RamyJEMeta } from "/opt/buildhome/repo/pages/public/[buuid]/payment.vue?macro=true";
import { default as indexq1Ax_45IyCVtcMYujrPce9I7zRfH8IQNKhdOAZ0JUhpuoMeta } from "/opt/buildhome/repo/pages/store/pos/orders/index.vue?macro=true";
import { default as orderuwnlAo5odL_45EPwdixzrx4b1ng_Va4MhDqhKPg9Q3nXIMeta } from "/opt/buildhome/repo/pages/store/pos/orders/order.vue?macro=true";
import { default as checkout_4561a3IZGADZJ1TQyjHf_YIjW_92Sq5mt2MB6TTVa7lsMeta } from "/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/checkout.vue?macro=true";
import { default as indexAQaRW8_45FqKBhLUjQacpqIqLte8cxSiOUTTI6Z5m_45Dp4Meta } from "/opt/buildhome/repo/pages/super-admin/users/index.vue?macro=true";
import { default as confirmedINfvGXe6dsm_555ks1ndhUmrNlk6VTTYD_7p1SscEpUMeta } from "/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/confirmed.vue?macro=true";
import { default as indexLRK1RMEScKS6yPHPsKji9Em33ZsM4aDHZUN1K_iXGYwMeta } from "/opt/buildhome/repo/pages/app/expenses/types/index.vue?macro=true";
import { default as categoriesB9UfOST4xBA5W3DVoIL7t1zP22x5YdtrNFpeQj_Am_wMeta } from "/opt/buildhome/repo/pages/public/[buuid]/categories.vue?macro=true";
import { default as indexi9T6pOB_skPUENL8MImbqOv8utgzvarGwUW_45cdB1xQsMeta } from "/opt/buildhome/repo/pages/app/checks/[checkId]/index.vue?macro=true";
import { default as index4cwG9G_9DgBmcHgNQ_45P0zoETy7DfMczf8XEsty6cTDMMeta } from "/opt/buildhome/repo/pages/app/expenses/sources/index.vue?macro=true";
import { default as indexIZy7VpuJQc7U5Jbe35EnD_45pFDNDsaQddOoYBsJB7s6AMeta } from "/opt/buildhome/repo/pages/app/payment/settings/index.vue?macro=true";
import { default as _91orderId_93tNAQQPf8Jw0DmvUJMMb_vxAWrtaWEnrttynG7P08SysMeta } from "/opt/buildhome/repo/pages/store/pos/orders/[orderId].vue?macro=true";
import { default as addBG3cdKDzObdz_bNEixIunJdK4ZHFdNxyZ0qJmB4AB7gMeta } from "/opt/buildhome/repo/pages/super-admin/businesses/add.vue?macro=true";
import { default as indexnkTNCcLWw1cu52NAViI9_45UXhrmg0p9phwfxbRPtFVLYMeta } from "/opt/buildhome/repo/pages/app/inventory/reports/index.vue?macro=true";
import { default as categoriesF5E1RHXH0RwCPeyNG9fL8xt1S5zYUX39PCPYo2tM4OQMeta } from "/opt/buildhome/repo/pages/app/kds-stations/categories.vue?macro=true";
import { default as _91shiftId_93_46backuppcvHtbUfZY3l_wYt_Nz_4539_kXh51BT7aKe6OBbKLc2EMeta } from "/opt/buildhome/repo/pages/app/shifts/[shiftId].backup.vue?macro=true";
import { default as optionsR6ICh27fukxTKDrOcqOyhyT3EQok2xkA61hbMFYSP2gMeta } from "/opt/buildhome/repo/pages/app/combos/[comboId]/options.vue?macro=true";
import { default as indexdINmz_4530H_MrXLRIA1LwFubdMdTm4mvHa73BJQFSlngMeta } from "/opt/buildhome/repo/pages/super-admin/businesses/index.vue?macro=true";
import { default as editK8g12FhXah4eom9fpQnpv_45DpcEPdL2Sfs6wvsYacIBwMeta } from "/opt/buildhome/repo/pages/app/products/[productId]/edit.vue?macro=true";
import { default as revisionsAWx_o8wz49_QXtGLkuBoCwJOOVCua9KHjAmHg9eTJoUMeta } from "/opt/buildhome/repo/pages/app/checks/[checkId]/revisions.vue?macro=true";
import { default as metrics5Ty9Tm_4tM7Cxh6FMS7aeoHE64cCK3SrCfuvndLID_sMeta } from "/opt/buildhome/repo/pages/super-admin/businesses/metrics.vue?macro=true";
import { default as editBXkki_RlDhV3BLqtHAYEw6Qr8QO9L7KeJmmcgkTOfHkMeta } from "/opt/buildhome/repo/pages/app/customers/[customerId]/edit.vue?macro=true";
import { default as viewl3fyb1_45v0Z3bUGD1KGcTOm_w4HNYPY_45YxeaiUj1tdsIMeta } from "/opt/buildhome/repo/pages/app/customers/[customerId]/view.vue?macro=true";
import { default as low_45stock_45X7mEU0uDJPQDQI7slac_vE6qKKbtTIrx6Yl8xx7So0Meta } from "/opt/buildhome/repo/pages/app/inventory/reports/low-stock.vue?macro=true";
import { default as movementsejVrqW_45CsUynVwW5lwH75btQ0_Z61A48f1M2SUzF_456oMeta } from "/opt/buildhome/repo/pages/app/inventory/reports/movements.vue?macro=true";
import { default as recipe1Lf8kY1bmTwlakOIg2_dz2425_2cGT3m9V32EtRJmVUMeta } from "/opt/buildhome/repo/pages/app/products/[productId]/recipe.vue?macro=true";
import { default as _91businessUuid_93hdSRIJmfKAS6_45p5mjTl9ZXqJpLlFeB4Cp9I7Gc208_45wMeta } from "/opt/buildhome/repo/pages/app/business/edit/[businessUuid].vue?macro=true";
import { default as editoAB_l3tGHQlAvcKbp73_Uc3gpch2iRzaYkgm87XOy5MMeta } from "/opt/buildhome/repo/pages/super-admin/businesses/[id]/edit.vue?macro=true";
import { default as addtRcJnr5ro34Z0IkK_45ZULmiAFNO9edqLTQJPSa6gZW4cMeta } from "/opt/buildhome/repo/pages/super-admin/users-businesses/add.vue?macro=true";
import { default as indexwK_fUsBUZTBw0dnoxHLeCeG46xUoSKlAu8MN407GvqgMeta } from "/opt/buildhome/repo/pages/super-admin/businesses/[id]/index.vue?macro=true";
import { default as stock_45levels4gqhzbYznhbYrI70__45Ek1EQyigEerpB8a6LCFSFbJOUMeta } from "/opt/buildhome/repo/pages/app/inventory/reports/stock-levels.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "links___en",
    path: "/en/links",
    component: () => import("/opt/buildhome/repo/pages/links.vue")
  },
  {
    name: "links___es",
    path: "/links",
    component: () => import("/opt/buildhome/repo/pages/links.vue")
  },
  {
    name: "paused___en",
    path: "/en/paused",
    component: () => import("/opt/buildhome/repo/pages/paused.vue")
  },
  {
    name: "paused___es",
    path: "/paused",
    component: () => import("/opt/buildhome/repo/pages/paused.vue")
  },
  {
    name: "index-old___en",
    path: "/en/index-old",
    component: () => import("/opt/buildhome/repo/pages/index-old.vue")
  },
  {
    name: "index-old___es",
    path: "/index-old",
    component: () => import("/opt/buildhome/repo/pages/index-old.vue")
  },
  {
    name: "thank-you___en",
    path: "/en/thank-you",
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue")
  },
  {
    name: "thank-you___es",
    path: "/thank-you",
    component: () => import("/opt/buildhome/repo/pages/thank-you.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    component: () => import("/opt/buildhome/repo/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/auth/login",
    component: () => import("/opt/buildhome/repo/pages/auth/login.vue")
  },
  {
    name: "auth-magic___en",
    path: "/en/auth/magic",
    component: () => import("/opt/buildhome/repo/pages/auth/magic.vue")
  },
  {
    name: "auth-magic___es",
    path: "/auth/magic",
    component: () => import("/opt/buildhome/repo/pages/auth/magic.vue")
  },
  {
    name: "cafeterias___en",
    path: "/en/cafeterias",
    component: () => import("/opt/buildhome/repo/pages/cafeterias.vue")
  },
  {
    name: "cafeterias___es",
    path: "/cafeterias",
    component: () => import("/opt/buildhome/repo/pages/cafeterias.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("/opt/buildhome/repo/pages/contact-us.vue")
  },
  {
    name: "contact-us___es",
    path: "/contact-us",
    component: () => import("/opt/buildhome/repo/pages/contact-us.vue")
  },
  {
    name: "heladerias___en",
    path: "/en/heladerias",
    component: () => import("/opt/buildhome/repo/pages/heladerias.vue")
  },
  {
    name: "heladerias___es",
    path: "/heladerias",
    component: () => import("/opt/buildhome/repo/pages/heladerias.vue")
  },
  {
    name: "auth-accept___en",
    path: "/en/auth/accept",
    component: () => import("/opt/buildhome/repo/pages/auth/accept.vue")
  },
  {
    name: "auth-accept___es",
    path: "/auth/accept",
    component: () => import("/opt/buildhome/repo/pages/auth/accept.vue")
  },
  {
    name: "auth-logout___en",
    path: "/en/auth/logout",
    component: () => import("/opt/buildhome/repo/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___es",
    path: "/auth/logout",
    component: () => import("/opt/buildhome/repo/pages/auth/logout.vue")
  },
  {
    name: "unauthorized___en",
    path: "/en/unauthorized",
    meta: { ...(unauthorizedT6bVzQtrm0wq5Ee_45kre8DjucvPItFNERR8dRfIs9lZAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/unauthorized.vue")
  },
  {
    name: "unauthorized___es",
    path: "/unauthorized",
    meta: { ...(unauthorizedT6bVzQtrm0wq5Ee_45kre8DjucvPItFNERR8dRfIs9lZAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/unauthorized.vue")
  },
  {
    name: "app-combos-add___en",
    path: "/en/app/combos/add",
    meta: { ...(addGUc158IxqdJOzgeYV92voxgodN4om3eWLFXaHaYONnwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/add.vue")
  },
  {
    name: "app-combos-add___es",
    path: "/app/combos/add",
    meta: { ...(addGUc158IxqdJOzgeYV92voxgodN4om3eWLFXaHaYONnwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/add.vue")
  },
  {
    name: "test-renderers___en",
    path: "/en/test-renderers",
    component: () => import("/opt/buildhome/repo/pages/test-renderers.vue")
  },
  {
    name: "test-renderers___es",
    path: "/test-renderers",
    component: () => import("/opt/buildhome/repo/pages/test-renderers.vue")
  },
  {
    name: "app-cache___en",
    path: "/en/app/cache",
    meta: { ...(indexBW6CbCcVwx1gWzJxQ8wQSENQN8FIJiqOWP1ocVRKAn8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/cache/index.vue")
  },
  {
    name: "app-cache___es",
    path: "/app/cache",
    meta: { ...(indexBW6CbCcVwx1gWzJxQ8wQSENQN8FIJiqOWP1ocVRKAn8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/cache/index.vue")
  },
  {
    name: "app-users___en",
    path: "/en/app/users",
    meta: { ...(indexe8KllPMvIq_45SV1VRqFMYTYn3604DPSl_yu7VNg00j8wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/users/index.vue")
  },
  {
    name: "app-users___es",
    path: "/app/users",
    meta: { ...(indexe8KllPMvIq_45SV1VRqFMYTYn3604DPSl_yu7VNg00j8wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/users/index.vue")
  },
  {
    name: "store-pos___en",
    path: "/en/store/pos",
    meta: { ...(indexShzoG6MxpypNRrYY1wQoENwGVj2y0WkJ0jtn1HYPazgMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/index.vue")
  },
  {
    name: "store-pos___es",
    path: "/store/pos",
    meta: { ...(indexShzoG6MxpypNRrYY1wQoENwGVj2y0WkJ0jtn1HYPazgMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/index.vue")
  },
  {
    name: "store-pos-shift___en",
    path: "/en/store/pos/shift",
    meta: { ...(shift1bdjLmSaJYmHpFHgufOC4ggSYZaWE3e_ipbVtc4hb7oMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/shift.vue"),
    children: [
  {
    name: "store-pos-shift-shiftId___en",
    path: ":shiftId()",
    meta: { ...(_91shiftId_93VjbLHoiVSfQM58YvF8nB5nCfdtc7KsBDITjSpdDHjFMMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/shift/[shiftId].vue")
  }
]
  },
  {
    name: "store-pos-shift___es",
    path: "/store/pos/shift",
    meta: { ...(shift1bdjLmSaJYmHpFHgufOC4ggSYZaWE3e_ipbVtc4hb7oMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/shift.vue"),
    children: [
  {
    name: "store-pos-shift-shiftId___es",
    path: ":shiftId()",
    meta: { ...(_91shiftId_93VjbLHoiVSfQM58YvF8nB5nCfdtc7KsBDITjSpdDHjFMMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/shift/[shiftId].vue")
  }
]
  },
  {
    name: "app-checks-audit___en",
    path: "/en/app/checks/audit",
    meta: { ...(auditTtuCPwIR53xmPUjhjyKG_45VWJJ5QYAo4WFT4GiahNk3IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/audit.vue")
  },
  {
    name: "app-checks-audit___es",
    path: "/app/checks/audit",
    meta: { ...(auditTtuCPwIR53xmPUjhjyKG_45VWJJ5QYAo4WFT4GiahNk3IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/audit.vue")
  },
  {
    name: "app-checks___en",
    path: "/en/app/checks",
    meta: { ...(indexc15Hj1RNSyVH5Sqg4LuHK8QKyCkac6A_21vihS70bloMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/index.vue")
  },
  {
    name: "app-checks___es",
    path: "/app/checks",
    meta: { ...(indexc15Hj1RNSyVH5Sqg4LuHK8QKyCkac6A_21vihS70bloMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/index.vue")
  },
  {
    name: "app-combos___en",
    path: "/en/app/combos",
    meta: { ...(indexXE0IWh3d9H4rgeSliI638Jg_45thoELGUCMV4udG9Yg6EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/index.vue")
  },
  {
    name: "app-combos___es",
    path: "/app/combos",
    meta: { ...(indexXE0IWh3d9H4rgeSliI638Jg_45thoELGUCMV4udG9Yg6EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/index.vue")
  },
  {
    name: "app-orders-audit___en",
    path: "/en/app/orders/audit",
    meta: { ...(auditkCzaRtr9pV69STqKoKb6YtSK7zP51k3NU_45_45IxNbeOqcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/audit.vue")
  },
  {
    name: "app-orders-audit___es",
    path: "/app/orders/audit",
    meta: { ...(auditkCzaRtr9pV69STqKoKb6YtSK7zP51k3NU_45_45IxNbeOqcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/audit.vue")
  },
  {
    name: "app-orders___en",
    path: "/en/app/orders",
    meta: { ...(indexfsJcZBO8KinUMNXFsa_sOy7U5UkX6O16qs1PwV6G_45d0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/index.vue")
  },
  {
    name: "app-orders___es",
    path: "/app/orders",
    meta: { ...(indexfsJcZBO8KinUMNXFsa_sOy7U5UkX6O16qs1PwV6G_45d0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/index.vue")
  },
  {
    name: "app-poc-products___en",
    path: "/en/app/poc/products",
    component: () => import("/opt/buildhome/repo/pages/app/poc/products.vue")
  },
  {
    name: "app-poc-products___es",
    path: "/app/poc/products",
    component: () => import("/opt/buildhome/repo/pages/app/poc/products.vue")
  },
  {
    name: "app-products-add___en",
    path: "/en/app/products/add",
    meta: { ...(addMw3owUdOyB0ov8VgWNF5H4h6JPRjQYRUqUrWLhqJLXAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/add.vue")
  },
  {
    name: "app-products-add___es",
    path: "/app/products/add",
    meta: { ...(addMw3owUdOyB0ov8VgWNF5H4h6JPRjQYRUqUrWLhqJLXAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/add.vue")
  },
  {
    name: "app-shifts___en",
    path: "/en/app/shifts",
    meta: { ...(indexQdiYHXy94eff7zVdeCF6kY43SRGGR2KBmmXbLG1B8acMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/shifts/index.vue")
  },
  {
    name: "app-shifts___es",
    path: "/app/shifts",
    meta: { ...(indexQdiYHXy94eff7zVdeCF6kY43SRGGR2KBmmXbLG1B8acMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/shifts/index.vue")
  },
  {
    name: "app-tables___en",
    path: "/en/app/tables",
    meta: { ...(index9BfHbU80pTr1tod_45E848_C0c48lr_Rpigs5afLlqyEQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/tables/index.vue")
  },
  {
    name: "app-tables___es",
    path: "/app/tables",
    meta: { ...(index9BfHbU80pTr1tod_45E848_C0c48lr_Rpigs5afLlqyEQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/tables/index.vue")
  },
  {
    name: "auth-no-business___en",
    path: "/en/auth/no-business",
    component: () => import("/opt/buildhome/repo/pages/auth/no-business.vue")
  },
  {
    name: "auth-no-business___es",
    path: "/auth/no-business",
    component: () => import("/opt/buildhome/repo/pages/auth/no-business.vue")
  },
  {
    name: "store-pos-combos___en",
    path: "/en/store/pos/combos",
    meta: combosG7oG_45vECdHGtDRiaE66KFjfNub5mHKxTVqywJC2xO3cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/store/pos/combos.vue")
  },
  {
    name: "store-pos-combos___es",
    path: "/store/pos/combos",
    meta: combosG7oG_45vECdHGtDRiaE66KFjfNub5mHKxTVqywJC2xO3cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/store/pos/combos.vue")
  },
  {
    name: "app-customers-add___en",
    path: "/en/app/customers/add",
    meta: { ...(addjuZ_45iJmNH9bc_45O7eGRClaJY6qYsLPA7ymVzSEAZxvd4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/add.vue")
  },
  {
    name: "app-customers-add___es",
    path: "/app/customers/add",
    meta: { ...(addjuZ_45iJmNH9bc_45O7eGRClaJY6qYsLPA7ymVzSEAZxvd4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/add.vue")
  },
  {
    name: "app-orders-uuid___en",
    path: "/en/app/orders/:uuid()",
    meta: { ...(_91uuid_93YD48OVIoyd1wOIF6wOtLXO0VaHls_wkrH4FLEnuNuv4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/[uuid].vue")
  },
  {
    name: "app-orders-uuid___es",
    path: "/app/orders/:uuid()",
    meta: { ...(_91uuid_93YD48OVIoyd1wOIF6wOtLXO0VaHls_wkrH4FLEnuNuv4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/orders/[uuid].vue")
  },
  {
    name: "app-products-list___en",
    path: "/en/app/products/list",
    meta: { ...(listsHkKtvszNv4zRjg5I1TfLD_45J9waYbcVkTy9ZkRArj_MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/list.vue")
  },
  {
    name: "app-products-list___es",
    path: "/app/products/list",
    meta: { ...(listsHkKtvszNv4zRjg5I1TfLD_45J9waYbcVkTy9ZkRArj_MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/list.vue")
  },
  {
    name: "app-recipes___en",
    path: "/en/app/recipes",
    meta: { ...(indexolvE5_45NVAUYBB6YmiBl_BBTVLDSSzsED5OKpbZ0nx7IMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/recipes/index.vue")
  },
  {
    name: "app-recipes___es",
    path: "/app/recipes",
    meta: { ...(indexolvE5_45NVAUYBB6YmiBl_BBTVLDSSzsED5OKpbZ0nx7IMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/recipes/index.vue")
  },
  {
    name: "app-reports___en",
    path: "/en/app/reports",
    meta: { ...(indexHHMgcZIu3Nt31I5LCLVnat1EDqFg9bJ0rUpsKDV3W74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/reports/index.vue")
  },
  {
    name: "app-reports___es",
    path: "/app/reports",
    meta: { ...(indexHHMgcZIu3Nt31I5LCLVnat1EDqFg9bJ0rUpsKDV3W74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/reports/index.vue")
  },
  {
    name: "app-servers___en",
    path: "/en/app/servers",
    meta: { ...(indexSKYEo0e_45YqMDkaqT7YI5Pf_HsYAqDuRFDcb_wN5Smu4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/servers/index.vue")
  },
  {
    name: "app-servers___es",
    path: "/app/servers",
    meta: { ...(indexSKYEo0e_45YqMDkaqT7YI5Pf_HsYAqDuRFDcb_wN5Smu4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/servers/index.vue")
  },
  {
    name: "auth-set-password___en",
    path: "/en/auth/set-password",
    component: () => import("/opt/buildhome/repo/pages/auth/set-password.vue")
  },
  {
    name: "auth-set-password___es",
    path: "/auth/set-password",
    component: () => import("/opt/buildhome/repo/pages/auth/set-password.vue")
  },
  {
    name: "super-admin___en",
    path: "/en/super-admin",
    meta: { ...(index9e3rgNKpikcF9bhBs681GWqNjZ1XJzmgiSAGLeoZ5MwMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/index.vue")
  },
  {
    name: "super-admin___es",
    path: "/super-admin",
    meta: { ...(index9e3rgNKpikcF9bhBs681GWqNjZ1XJzmgiSAGLeoZ5MwMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/index.vue")
  },
  {
    name: "app-business___en",
    path: "/en/app/business",
    meta: { ...(indexMbptbF10kzZFETjDbqqvyT76vW_pKA3CapCR3O9mwdEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/business/index.vue")
  },
  {
    name: "app-business___es",
    path: "/app/business",
    meta: { ...(indexMbptbF10kzZFETjDbqqvyT76vW_pKA3CapCR3O9mwdEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/business/index.vue")
  },
  {
    name: "app-expenses___en",
    path: "/en/app/expenses",
    meta: { ...(indexh8dhAqplKt80eWTZIOX5jeZmD9UJI6QBapzJMOjRJVAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/index.vue")
  },
  {
    name: "app-expenses___es",
    path: "/app/expenses",
    meta: { ...(indexh8dhAqplKt80eWTZIOX5jeZmD9UJI6QBapzJMOjRJVAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/index.vue")
  },
  {
    name: "app-products___en",
    path: "/en/app/products",
    meta: { ...(indexqw3meEakqKPOx_bcFwNa66yoAe9kO6zxrDh2TSqS2PoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/index.vue")
  },
  {
    name: "app-products___es",
    path: "/app/products",
    meta: { ...(indexqw3meEakqKPOx_bcFwNa66yoAe9kO6zxrDh2TSqS2PoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/index.vue")
  },
  {
    name: "auth-confirm-email___en",
    path: "/en/auth/confirm-email",
    component: () => import("/opt/buildhome/repo/pages/auth/confirm-email.vue")
  },
  {
    name: "auth-confirm-email___es",
    path: "/auth/confirm-email",
    component: () => import("/opt/buildhome/repo/pages/auth/confirm-email.vue")
  },
  {
    name: "app-business-create___en",
    path: "/en/app/business/create",
    meta: { ...(createZbOMBl5Pslf9cj0gH0B6PiaYL2wHPZO2FyiocsVcrYYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/business/create.vue")
  },
  {
    name: "app-business-create___es",
    path: "/app/business/create",
    meta: { ...(createZbOMBl5Pslf9cj0gH0B6PiaYL2wHPZO2FyiocsVcrYYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/business/create.vue")
  },
  {
    name: "app-customers___en",
    path: "/en/app/customers",
    meta: { ...(indexpKz3rwmjFSo8ve_l9ppabEyxpzyv9vA2ACnE2ZQT2fYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/index.vue")
  },
  {
    name: "app-customers___es",
    path: "/app/customers",
    meta: { ...(indexpKz3rwmjFSo8ve_l9ppabEyxpzyv9vA2ACnE2ZQT2fYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/index.vue")
  },
  {
    name: "app-discounts___en",
    path: "/en/app/discounts",
    meta: { ...(indexOANRVXZmdIAE28NckOF_b6l3GMrhf3YM4rALvgDpp1oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/discounts/index.vue")
  },
  {
    name: "app-discounts___es",
    path: "/app/discounts",
    meta: { ...(indexOANRVXZmdIAE28NckOF_b6l3GMrhf3YM4rALvgDpp1oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/discounts/index.vue")
  },
  {
    name: "app-financial___en",
    path: "/en/app/financial",
    meta: { ...(indexJQ210kovHWmSgT2nIo5KUZTCFR32by8hgdUktRT8K4MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/financial/index.vue")
  },
  {
    name: "app-financial___es",
    path: "/app/financial",
    meta: { ...(indexJQ210kovHWmSgT2nIo5KUZTCFR32by8hgdUktRT8K4MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/financial/index.vue")
  },
  {
    name: "app-modifiers___en",
    path: "/en/app/modifiers",
    meta: { ...(indexMrO1p01kuYTK3JtzAQYbqpJ7kzSUrHgbM7FEPbxk_45vkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/modifiers/index.vue")
  },
  {
    name: "app-modifiers___es",
    path: "/app/modifiers",
    meta: { ...(indexMrO1p01kuYTK3JtzAQYbqpJ7kzSUrHgbM7FEPbxk_45vkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/modifiers/index.vue")
  },
  {
    name: "app-products-import___en",
    path: "/en/app/products/import",
    meta: { ...(importOMMkcwdVtK5_w9IWZw9wVA3SmsQ2C1grPkW_FEvF690Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/import.vue")
  },
  {
    name: "app-products-import___es",
    path: "/app/products/import",
    meta: { ...(importOMMkcwdVtK5_w9IWZw9wVA3SmsQ2C1grPkW_FEvF690Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/products/import.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    component: () => import("/opt/buildhome/repo/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___es",
    path: "/auth/reset-password",
    component: () => import("/opt/buildhome/repo/pages/auth/reset-password.vue")
  },
  {
    name: "public-buuid-test___en",
    path: "/en/public/:buuid()/test",
    meta: { ...(testd_PgHfO70uDMb7vPCxLck49Ub8xfZSJkbsPA2vjXxcMMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/test.vue")
  },
  {
    name: "public-buuid-test___es",
    path: "/public/:buuid()/test",
    meta: { ...(testd_PgHfO70uDMb7vPCxLck49Ub8xfZSJkbsPA2vjXxcMMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/test.vue")
  },
  {
    name: "store-pos-inventory___en",
    path: "/en/store/pos/inventory",
    meta: { ...(inventorypKF8ZjbTvjiDzm39ogLM0aIq1sx6YoJKy1_45j0F64IgsMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/inventory.vue")
  },
  {
    name: "store-pos-inventory___es",
    path: "/store/pos/inventory",
    meta: { ...(inventorypKF8ZjbTvjiDzm39ogLM0aIq1sx6YoJKy1_45j0F64IgsMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/inventory.vue")
  },
  {
    name: "store-pos-kds___en",
    path: "/en/store/pos/kds",
    meta: { ...(indexH8Kc4CWtTg_nrsenK4gnl7DLwRFVFJ_tSAhAn_45a55e4Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/kds/index.vue")
  },
  {
    name: "store-pos-kds___es",
    path: "/store/pos/kds",
    meta: { ...(indexH8Kc4CWtTg_nrsenK4gnl7DLwRFVFJ_tSAhAn_45a55e4Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/kds/index.vue")
  },
  {
    name: "tienda-slug___en",
    path: "/en/tienda/:slug()",
    meta: indexjeSnNEYYAcz_45BImCGanjyWmO7mmTejcMW5a_h7H899gMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/index.vue")
  },
  {
    name: "tienda-slug___es",
    path: "/tienda/:slug()",
    meta: indexjeSnNEYYAcz_45BImCGanjyWmO7mmTejcMW5a_h7H899gMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/index.vue")
  },
  {
    name: "app-admin-email-test___en",
    path: "/en/app/admin/email-test",
    meta: { ...(email_45testwih0Sx_eGmIKD2Hu3bAa5xdAVXSxnzto3y41V3lNZpEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/admin/email-test.vue")
  },
  {
    name: "app-admin-email-test___es",
    path: "/app/admin/email-test",
    meta: { ...(email_45testwih0Sx_eGmIKD2Hu3bAa5xdAVXSxnzto3y41V3lNZpEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/admin/email-test.vue")
  },
  {
    name: "app-categories___en",
    path: "/en/app/categories",
    meta: { ...(index3hMtL7kpiEKtsKSXdhFsypTof4Ms_9nWLXrj4RsYwbMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/categories/index.vue")
  },
  {
    name: "app-categories___es",
    path: "/app/categories",
    meta: { ...(index3hMtL7kpiEKtsKSXdhFsypTof4Ms_9nWLXrj4RsYwbMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/categories/index.vue")
  },
  {
    name: "app-shifts-shiftId___en",
    path: "/en/app/shifts/:shiftId()",
    meta: _91shiftId_9394imajGxe0ogKrb1XiMNEH6T_DM_1B5hNGRYuuxMEP8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/app/shifts/[shiftId].vue")
  },
  {
    name: "app-shifts-shiftId___es",
    path: "/app/shifts/:shiftId()",
    meta: _91shiftId_9394imajGxe0ogKrb1XiMNEH6T_DM_1B5hNGRYuuxMEP8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/app/shifts/[shiftId].vue")
  },
  {
    name: "auth-forgot-password___en",
    path: "/en/auth/forgot-password",
    component: () => import("/opt/buildhome/repo/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___es",
    path: "/auth/forgot-password",
    component: () => import("/opt/buildhome/repo/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-select-business___en",
    path: "/en/auth/select-business",
    component: () => import("/opt/buildhome/repo/pages/auth/select-business.vue")
  },
  {
    name: "auth-select-business___es",
    path: "/auth/select-business",
    component: () => import("/opt/buildhome/repo/pages/auth/select-business.vue")
  },
  {
    name: "auth-switch-business___en",
    path: "/en/auth/switch-business",
    component: () => import("/opt/buildhome/repo/pages/auth/switch-business.vue")
  },
  {
    name: "auth-switch-business___es",
    path: "/auth/switch-business",
    component: () => import("/opt/buildhome/repo/pages/auth/switch-business.vue")
  },
  {
    name: "public-buuid-clear___en",
    path: "/en/public/:buuid()/clear",
    meta: { ...(clearu7ATq7ph7x1XWmHHZaVdbt4evW_452IXTLKjZslMvTXJ8Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/clear.vue")
  },
  {
    name: "public-buuid-clear___es",
    path: "/public/:buuid()/clear",
    meta: { ...(clearu7ATq7ph7x1XWmHHZaVdbt4evW_452IXTLKjZslMvTXJ8Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/clear.vue")
  },
  {
    name: "public-buuid___en",
    path: "/en/public/:buuid()",
    meta: { ...(indexyjKrT_Gz4WtkCONq9hH4UmFTUKGB2dqZGFcJ8n1OWzQMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/index.vue")
  },
  {
    name: "public-buuid___es",
    path: "/public/:buuid()",
    meta: { ...(indexyjKrT_Gz4WtkCONq9hH4UmFTUKGB2dqZGFcJ8n1OWzQMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/index.vue")
  },
  {
    name: "public-buuid-login___en",
    path: "/en/public/:buuid()/login",
    meta: loginEnSIS3ooY1q5RGolUfqvBIbLXn5tQOhz8_45i8GmPA2xgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/login.vue")
  },
  {
    name: "public-buuid-login___es",
    path: "/public/:buuid()/login",
    meta: loginEnSIS3ooY1q5RGolUfqvBIbLXn5tQOhz8_45i8GmPA2xgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/login.vue")
  },
  {
    name: "store-products___en",
    path: "/en/store/products",
    meta: { ...(indexfuE8bwNB8TXg0rY1jD_45KY0XQeDNtaZRO87aT2ZsCJQ8Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/products/index.vue")
  },
  {
    name: "store-products___es",
    path: "/store/products",
    meta: { ...(indexfuE8bwNB8TXg0rY1jD_45KY0XQeDNtaZRO87aT2ZsCJQ8Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/products/index.vue")
  },
  {
    name: "app-ingredients___en",
    path: "/en/app/ingredients",
    meta: { ...(indexzSFF5WzeJF68_45Ou9fzU_kiuBJGxRLBB2V8xeRzfcf98Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/ingredients/index.vue")
  },
  {
    name: "app-ingredients___es",
    path: "/app/ingredients",
    meta: { ...(indexzSFF5WzeJF68_45Ou9fzU_kiuBJGxRLBB2V8xeRzfcf98Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/ingredients/index.vue")
  },
  {
    name: "app-stock-items___en",
    path: "/en/app/stock-items",
    meta: { ...(indexOnB2KbcUqUff2IGeqUEHwVHUwTW55ovE2zRe4cKrJrkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/stock-items/index.vue")
  },
  {
    name: "app-stock-items___es",
    path: "/app/stock-items",
    meta: { ...(indexOnB2KbcUqUff2IGeqUEHwVHUwTW55ovE2zRe4cKrJrkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/stock-items/index.vue")
  },
  {
    name: "app-system-pos-config___en",
    path: "/en/app/system/pos-config",
    meta: { ...(pos_45configMQd3L2vx3fV5AJx9TByYkeHMr3BKvhMflTrGXPTk3mMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/system/pos-config.vue")
  },
  {
    name: "app-system-pos-config___es",
    path: "/app/system/pos-config",
    meta: { ...(pos_45configMQd3L2vx3fV5AJx9TByYkeHMr3BKvhMflTrGXPTk3mMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/system/pos-config.vue")
  },
  {
    name: "app-testing-jwt___en",
    path: "/en/app/testing/jwt",
    meta: { ...(indexJfDTaqhp263L95QGRw9_aWYOmmKPDSenbu0qecjK4lIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/testing/jwt/index.vue")
  },
  {
    name: "app-testing-jwt___es",
    path: "/app/testing/jwt",
    meta: { ...(indexJfDTaqhp263L95QGRw9_aWYOmmKPDSenbu0qecjK4lIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/testing/jwt/index.vue")
  },
  {
    name: "public-buuid-combos___en",
    path: "/en/public/:buuid()/combos",
    meta: { ...(combosxkGf7ST_45auhsy83Vv9fHw9wj0MTE4L0YdcN_45OVTdx2UMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/combos.vue")
  },
  {
    name: "public-buuid-combos___es",
    path: "/public/:buuid()/combos",
    meta: { ...(combosxkGf7ST_45auhsy83Vv9fHw9wj0MTE4L0YdcN_45OVTdx2UMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/combos.vue")
  },
  {
    name: "public-buuid-review___en",
    path: "/en/public/:buuid()/review",
    meta: { ...(reviewkrx7LUDdpkCvkzv7T2cYKjY277olavp0aZlBdZjF_k0Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/review.vue")
  },
  {
    name: "public-buuid-review___es",
    path: "/public/:buuid()/review",
    meta: { ...(reviewkrx7LUDdpkCvkzv7T2cYKjY277olavp0aZlBdZjF_k0Meta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/review.vue")
  },
  {
    name: "public-buuid-verify___en",
    path: "/en/public/:buuid()/verify",
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/verify.vue")
  },
  {
    name: "public-buuid-verify___es",
    path: "/public/:buuid()/verify",
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/verify.vue")
  },
  {
    name: "store-pos-orders-grid___en",
    path: "/en/store/pos/orders/grid",
    meta: { ...(gridCKZlWYdKk764dtyY7vbNNlQ0GfIx0NnV0IJlpq4BTysMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/grid.vue")
  },
  {
    name: "store-pos-orders-grid___es",
    path: "/store/pos/orders/grid",
    meta: { ...(gridCKZlWYdKk764dtyY7vbNNlQ0GfIx0NnV0IJlpq4BTysMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/grid.vue")
  },
  {
    name: "super-admin-users-add___en",
    path: "/en/super-admin/users/add",
    meta: { ...(add8hR6kXFOlH5fVTbkYCqf1t0L1SzY3PMkVbnNtWMfXzkMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users/add.vue")
  },
  {
    name: "super-admin-users-add___es",
    path: "/super-admin/users/add",
    meta: { ...(add8hR6kXFOlH5fVTbkYCqf1t0L1SzY3PMkVbnNtWMfXzkMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users/add.vue")
  },
  {
    name: "app-dining-areas___en",
    path: "/en/app/dining-areas",
    meta: { ...(indexB0nunpozYW_45Scs7gF6Vb5JUmAHaCq6hQGATwndWExIoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/dining-areas/index.vue")
  },
  {
    name: "app-dining-areas___es",
    path: "/app/dining-areas",
    meta: { ...(indexB0nunpozYW_45Scs7gF6Vb5JUmAHaCq6hQGATwndWExIoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/dining-areas/index.vue")
  },
  {
    name: "app-kds-stations___en",
    path: "/en/app/kds-stations",
    meta: { ...(indexYeq_45ZeCKdGYG7PIJpZcQaTFcbyMCb3U5o_QUkEQDJVcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/kds-stations/index.vue")
  },
  {
    name: "app-kds-stations___es",
    path: "/app/kds-stations",
    meta: { ...(indexYeq_45ZeCKdGYG7PIJpZcQaTFcbyMCb3U5o_QUkEQDJVcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/kds-stations/index.vue")
  },
  {
    name: "public-buuid-payment___en",
    path: "/en/public/:buuid()/payment",
    meta: { ...(paymente_45tBk4_45MDo6eqewErENnAuhcDehCycWDwSsW_45RamyJEMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/payment.vue")
  },
  {
    name: "public-buuid-payment___es",
    path: "/public/:buuid()/payment",
    meta: { ...(paymente_45tBk4_45MDo6eqewErENnAuhcDehCycWDwSsW_45RamyJEMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/payment.vue")
  },
  {
    name: "store-pos-orders___en",
    path: "/en/store/pos/orders",
    meta: { ...(indexq1Ax_45IyCVtcMYujrPce9I7zRfH8IQNKhdOAZ0JUhpuoMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/index.vue")
  },
  {
    name: "store-pos-orders___es",
    path: "/store/pos/orders",
    meta: { ...(indexq1Ax_45IyCVtcMYujrPce9I7zRfH8IQNKhdOAZ0JUhpuoMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/index.vue")
  },
  {
    name: "store-pos-orders-order___en",
    path: "/en/store/pos/orders/order",
    meta: { ...(orderuwnlAo5odL_45EPwdixzrx4b1ng_Va4MhDqhKPg9Q3nXIMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/order.vue")
  },
  {
    name: "store-pos-orders-order___es",
    path: "/store/pos/orders/order",
    meta: { ...(orderuwnlAo5odL_45EPwdixzrx4b1ng_Va4MhDqhKPg9Q3nXIMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/order.vue")
  },
  {
    name: "tienda-slug-checkout___en",
    path: "/en/tienda/:slug()/checkout",
    meta: checkout_4561a3IZGADZJ1TQyjHf_YIjW_92Sq5mt2MB6TTVa7lsMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/checkout.vue")
  },
  {
    name: "tienda-slug-checkout___es",
    path: "/tienda/:slug()/checkout",
    meta: checkout_4561a3IZGADZJ1TQyjHf_YIjW_92Sq5mt2MB6TTVa7lsMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/checkout.vue")
  },
  {
    name: "super-admin-users___en",
    path: "/en/super-admin/users",
    meta: { ...(indexAQaRW8_45FqKBhLUjQacpqIqLte8cxSiOUTTI6Z5m_45Dp4Meta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users/index.vue")
  },
  {
    name: "super-admin-users___es",
    path: "/super-admin/users",
    meta: { ...(indexAQaRW8_45FqKBhLUjQacpqIqLte8cxSiOUTTI6Z5m_45Dp4Meta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users/index.vue")
  },
  {
    name: "tienda-slug-confirmed___en",
    path: "/en/tienda/:slug()/confirmed",
    meta: confirmedINfvGXe6dsm_555ks1ndhUmrNlk6VTTYD_7p1SscEpUMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/confirmed.vue")
  },
  {
    name: "tienda-slug-confirmed___es",
    path: "/tienda/:slug()/confirmed",
    meta: confirmedINfvGXe6dsm_555ks1ndhUmrNlk6VTTYD_7p1SscEpUMeta || {},
    component: () => import("/opt/buildhome/repo/layers/tienda/pages/tienda/[slug]/confirmed.vue")
  },
  {
    name: "app-expenses-types___en",
    path: "/en/app/expenses/types",
    meta: { ...(indexLRK1RMEScKS6yPHPsKji9Em33ZsM4aDHZUN1K_iXGYwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/types/index.vue")
  },
  {
    name: "app-expenses-types___es",
    path: "/app/expenses/types",
    meta: { ...(indexLRK1RMEScKS6yPHPsKji9Em33ZsM4aDHZUN1K_iXGYwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/types/index.vue")
  },
  {
    name: "public-buuid-categories___en",
    path: "/en/public/:buuid()/categories",
    meta: { ...(categoriesB9UfOST4xBA5W3DVoIL7t1zP22x5YdtrNFpeQj_Am_wMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/categories.vue")
  },
  {
    name: "public-buuid-categories___es",
    path: "/public/:buuid()/categories",
    meta: { ...(categoriesB9UfOST4xBA5W3DVoIL7t1zP22x5YdtrNFpeQj_Am_wMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/public/[buuid]/categories.vue")
  },
  {
    name: "app-checks-checkId___en",
    path: "/en/app/checks/:checkId()",
    meta: { ...(indexi9T6pOB_skPUENL8MImbqOv8utgzvarGwUW_45cdB1xQsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/[checkId]/index.vue")
  },
  {
    name: "app-checks-checkId___es",
    path: "/app/checks/:checkId()",
    meta: { ...(indexi9T6pOB_skPUENL8MImbqOv8utgzvarGwUW_45cdB1xQsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/[checkId]/index.vue")
  },
  {
    name: "app-expenses-sources___en",
    path: "/en/app/expenses/sources",
    meta: { ...(index4cwG9G_9DgBmcHgNQ_45P0zoETy7DfMczf8XEsty6cTDMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/sources/index.vue")
  },
  {
    name: "app-expenses-sources___es",
    path: "/app/expenses/sources",
    meta: { ...(index4cwG9G_9DgBmcHgNQ_45P0zoETy7DfMczf8XEsty6cTDMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/expenses/sources/index.vue")
  },
  {
    name: "app-payment-settings___en",
    path: "/en/app/payment/settings",
    meta: { ...(indexIZy7VpuJQc7U5Jbe35EnD_45pFDNDsaQddOoYBsJB7s6AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/payment/settings/index.vue")
  },
  {
    name: "app-payment-settings___es",
    path: "/app/payment/settings",
    meta: { ...(indexIZy7VpuJQc7U5Jbe35EnD_45pFDNDsaQddOoYBsJB7s6AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/payment/settings/index.vue")
  },
  {
    name: "store-pos-orders-orderId___en",
    path: "/en/store/pos/orders/:orderId()",
    meta: { ...(_91orderId_93tNAQQPf8Jw0DmvUJMMb_vxAWrtaWEnrttynG7P08SysMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/[orderId].vue")
  },
  {
    name: "store-pos-orders-orderId___es",
    path: "/store/pos/orders/:orderId()",
    meta: { ...(_91orderId_93tNAQQPf8Jw0DmvUJMMb_vxAWrtaWEnrttynG7P08SysMeta || {}), ...{"middleware":["pos-auth"]} },
    component: () => import("/opt/buildhome/repo/pages/store/pos/orders/[orderId].vue")
  },
  {
    name: "super-admin-businesses-add___en",
    path: "/en/super-admin/businesses/add",
    meta: { ...(addBG3cdKDzObdz_bNEixIunJdK4ZHFdNxyZ0qJmB4AB7gMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/add.vue")
  },
  {
    name: "super-admin-businesses-add___es",
    path: "/super-admin/businesses/add",
    meta: { ...(addBG3cdKDzObdz_bNEixIunJdK4ZHFdNxyZ0qJmB4AB7gMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/add.vue")
  },
  {
    name: "app-inventory-reports___en",
    path: "/en/app/inventory/reports",
    meta: { ...(indexnkTNCcLWw1cu52NAViI9_45UXhrmg0p9phwfxbRPtFVLYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/index.vue")
  },
  {
    name: "app-inventory-reports___es",
    path: "/app/inventory/reports",
    meta: { ...(indexnkTNCcLWw1cu52NAViI9_45UXhrmg0p9phwfxbRPtFVLYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/index.vue")
  },
  {
    name: "app-kds-stations-categories___en",
    path: "/en/app/kds-stations/categories",
    meta: { ...(categoriesF5E1RHXH0RwCPeyNG9fL8xt1S5zYUX39PCPYo2tM4OQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/kds-stations/categories.vue")
  },
  {
    name: "app-kds-stations-categories___es",
    path: "/app/kds-stations/categories",
    meta: { ...(categoriesF5E1RHXH0RwCPeyNG9fL8xt1S5zYUX39PCPYo2tM4OQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/app/kds-stations/categories.vue")
  },
  {
    name: "app-shifts-shiftId.backup___en",
    path: "/en/app/shifts/:shiftId().backup",
    meta: _91shiftId_93_46backuppcvHtbUfZY3l_wYt_Nz_4539_kXh51BT7aKe6OBbKLc2EMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/shifts/[shiftId].backup.vue")
  },
  {
    name: "app-shifts-shiftId.backup___es",
    path: "/app/shifts/:shiftId().backup",
    meta: _91shiftId_93_46backuppcvHtbUfZY3l_wYt_Nz_4539_kXh51BT7aKe6OBbKLc2EMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/shifts/[shiftId].backup.vue")
  },
  {
    name: "app-combos-comboId-options___en",
    path: "/en/app/combos/:comboId()/options",
    meta: { ...(optionsR6ICh27fukxTKDrOcqOyhyT3EQok2xkA61hbMFYSP2gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/[comboId]/options.vue")
  },
  {
    name: "app-combos-comboId-options___es",
    path: "/app/combos/:comboId()/options",
    meta: { ...(optionsR6ICh27fukxTKDrOcqOyhyT3EQok2xkA61hbMFYSP2gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/combos/[comboId]/options.vue")
  },
  {
    name: "super-admin-businesses___en",
    path: "/en/super-admin/businesses",
    meta: { ...(indexdINmz_4530H_MrXLRIA1LwFubdMdTm4mvHa73BJQFSlngMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/index.vue")
  },
  {
    name: "super-admin-businesses___es",
    path: "/super-admin/businesses",
    meta: { ...(indexdINmz_4530H_MrXLRIA1LwFubdMdTm4mvHa73BJQFSlngMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/index.vue")
  },
  {
    name: "app-products-productId-edit___en",
    path: "/en/app/products/:productId()/edit",
    meta: { ...(editK8g12FhXah4eom9fpQnpv_45DpcEPdL2Sfs6wvsYacIBwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/products/[productId]/edit.vue")
  },
  {
    name: "app-products-productId-edit___es",
    path: "/app/products/:productId()/edit",
    meta: { ...(editK8g12FhXah4eom9fpQnpv_45DpcEPdL2Sfs6wvsYacIBwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/products/[productId]/edit.vue")
  },
  {
    name: "app-checks-checkId-revisions___en",
    path: "/en/app/checks/:checkId()/revisions",
    meta: { ...(revisionsAWx_o8wz49_QXtGLkuBoCwJOOVCua9KHjAmHg9eTJoUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/[checkId]/revisions.vue")
  },
  {
    name: "app-checks-checkId-revisions___es",
    path: "/app/checks/:checkId()/revisions",
    meta: { ...(revisionsAWx_o8wz49_QXtGLkuBoCwJOOVCua9KHjAmHg9eTJoUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/checks/[checkId]/revisions.vue")
  },
  {
    name: "super-admin-businesses-metrics___en",
    path: "/en/super-admin/businesses/metrics",
    meta: { ...(metrics5Ty9Tm_4tM7Cxh6FMS7aeoHE64cCK3SrCfuvndLID_sMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/metrics.vue")
  },
  {
    name: "super-admin-businesses-metrics___es",
    path: "/super-admin/businesses/metrics",
    meta: { ...(metrics5Ty9Tm_4tM7Cxh6FMS7aeoHE64cCK3SrCfuvndLID_sMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/metrics.vue")
  },
  {
    name: "app-customers-customerId-edit___en",
    path: "/en/app/customers/:customerId()/edit",
    meta: { ...(editBXkki_RlDhV3BLqtHAYEw6Qr8QO9L7KeJmmcgkTOfHkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/[customerId]/edit.vue")
  },
  {
    name: "app-customers-customerId-edit___es",
    path: "/app/customers/:customerId()/edit",
    meta: { ...(editBXkki_RlDhV3BLqtHAYEw6Qr8QO9L7KeJmmcgkTOfHkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/[customerId]/edit.vue")
  },
  {
    name: "app-customers-customerId-view___en",
    path: "/en/app/customers/:customerId()/view",
    meta: { ...(viewl3fyb1_45v0Z3bUGD1KGcTOm_w4HNYPY_45YxeaiUj1tdsIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/[customerId]/view.vue")
  },
  {
    name: "app-customers-customerId-view___es",
    path: "/app/customers/:customerId()/view",
    meta: { ...(viewl3fyb1_45v0Z3bUGD1KGcTOm_w4HNYPY_45YxeaiUj1tdsIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/customers/[customerId]/view.vue")
  },
  {
    name: "app-inventory-reports-low-stock___en",
    path: "/en/app/inventory/reports/low-stock",
    meta: { ...(low_45stock_45X7mEU0uDJPQDQI7slac_vE6qKKbtTIrx6Yl8xx7So0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/low-stock.vue")
  },
  {
    name: "app-inventory-reports-low-stock___es",
    path: "/app/inventory/reports/low-stock",
    meta: { ...(low_45stock_45X7mEU0uDJPQDQI7slac_vE6qKKbtTIrx6Yl8xx7So0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/low-stock.vue")
  },
  {
    name: "app-inventory-reports-movements___en",
    path: "/en/app/inventory/reports/movements",
    meta: { ...(movementsejVrqW_45CsUynVwW5lwH75btQ0_Z61A48f1M2SUzF_456oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/movements.vue")
  },
  {
    name: "app-inventory-reports-movements___es",
    path: "/app/inventory/reports/movements",
    meta: { ...(movementsejVrqW_45CsUynVwW5lwH75btQ0_Z61A48f1M2SUzF_456oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/movements.vue")
  },
  {
    name: "app-products-productId-recipe___en",
    path: "/en/app/products/:productId()/recipe",
    meta: { ...(recipe1Lf8kY1bmTwlakOIg2_dz2425_2cGT3m9V32EtRJmVUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/products/[productId]/recipe.vue")
  },
  {
    name: "app-products-productId-recipe___es",
    path: "/app/products/:productId()/recipe",
    meta: { ...(recipe1Lf8kY1bmTwlakOIg2_dz2425_2cGT3m9V32EtRJmVUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/products/[productId]/recipe.vue")
  },
  {
    name: "app-business-edit-businessUuid___en",
    path: "/en/app/business/edit/:businessUuid()",
    meta: { ...(_91businessUuid_93hdSRIJmfKAS6_45p5mjTl9ZXqJpLlFeB4Cp9I7Gc208_45wMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/business/edit/[businessUuid].vue")
  },
  {
    name: "app-business-edit-businessUuid___es",
    path: "/app/business/edit/:businessUuid()",
    meta: { ...(_91businessUuid_93hdSRIJmfKAS6_45p5mjTl9ZXqJpLlFeB4Cp9I7Gc208_45wMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/business/edit/[businessUuid].vue")
  },
  {
    name: "super-admin-businesses-id-edit___en",
    path: "/en/super-admin/businesses/:id()/edit",
    meta: { ...(editoAB_l3tGHQlAvcKbp73_Uc3gpch2iRzaYkgm87XOy5MMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/[id]/edit.vue")
  },
  {
    name: "super-admin-businesses-id-edit___es",
    path: "/super-admin/businesses/:id()/edit",
    meta: { ...(editoAB_l3tGHQlAvcKbp73_Uc3gpch2iRzaYkgm87XOy5MMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/[id]/edit.vue")
  },
  {
    name: "super-admin-users-businesses-add___en",
    path: "/en/super-admin/users-businesses/add",
    meta: { ...(addtRcJnr5ro34Z0IkK_45ZULmiAFNO9edqLTQJPSa6gZW4cMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users-businesses/add.vue")
  },
  {
    name: "super-admin-users-businesses-add___es",
    path: "/super-admin/users-businesses/add",
    meta: { ...(addtRcJnr5ro34Z0IkK_45ZULmiAFNO9edqLTQJPSa6gZW4cMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/users-businesses/add.vue")
  },
  {
    name: "super-admin-businesses-id___en",
    path: "/en/super-admin/businesses/:id()",
    meta: { ...(indexwK_fUsBUZTBw0dnoxHLeCeG46xUoSKlAu8MN407GvqgMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/[id]/index.vue")
  },
  {
    name: "super-admin-businesses-id___es",
    path: "/super-admin/businesses/:id()",
    meta: { ...(indexwK_fUsBUZTBw0dnoxHLeCeG46xUoSKlAu8MN407GvqgMeta || {}), ...{"middleware":["super-admin"]} },
    component: () => import("/opt/buildhome/repo/pages/super-admin/businesses/[id]/index.vue")
  },
  {
    name: "app-inventory-reports-stock-levels___en",
    path: "/en/app/inventory/reports/stock-levels",
    meta: { ...(stock_45levels4gqhzbYznhbYrI70__45Ek1EQyigEerpB8a6LCFSFbJOUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/stock-levels.vue")
  },
  {
    name: "app-inventory-reports-stock-levels___es",
    path: "/app/inventory/reports/stock-levels",
    meta: { ...(stock_45levels4gqhzbYznhbYrI70__45Ek1EQyigEerpB8a6LCFSFbJOUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/buildhome/repo/pages/app/inventory/reports/stock-levels.vue")
  }
]